import Link from "next/link";

export default function Footer() {
  return (
    <footer className="mt-10 bg-gray-900 py-10 text-white">
      <div className="container mx-auto px-4 lg:px-16">
        {/* Footer Grid */}
        <div className="grid grid-cols-1 items-start gap-8 md:grid-cols-3">
          {/* Branding Section */}
          <div>
            <h2 className="mb-4 text-2xl font-bold">Starlightopia</h2>
            <p className="text-gray-300">
              Your go-to place for quality products. Explore, dream, and shop
              with ease!
            </p>
            <p className="mt-4 text-gray-400">
              ©{new Date().getFullYear()} Starlightopia. All rights reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 text-xl font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/about"
                  className="text-gray-400 transition hover:text-white"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  href="/"
                  className="text-gray-400 transition hover:text-white"
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link
                  href="/contact-us"
                  className="text-gray-400 transition hover:text-white"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy-policy"
                  className="text-gray-400 transition hover:text-white"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms-and-conditions"
                  className="text-gray-400 transition hover:text-white"
                >
                  Terms & Conditions
                </Link>
              </li>
              {/* <li>
                <Link
                  href="/"
                  className="text-gray-400 hover:text-white transition"
                >
                  FAQ
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Social Media */}
          <div className="flex flex-col">
            <h3 className="mb-4 text-xl font-semibold">Follow Us</h3>
            <div className="flex space-x-4">
              {/* <Link
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-500 transition"
              >
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition"
              >
                <i className="fab fa-twitter"></i>
              </Link> */}

              <Link
                href="https://www.instagram.com/starlightopia/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 transition hover:text-pink-400"
                aria-label="Visit our Instagram profile"
              >
                <i className="fab fa-instagram fa-lg"></i>
              </Link>

              {/* <Link
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-700 transition"
              >
                <i className="fab fa-linkedin-in"></i>
              </Link> */}
            </div>

            <h3 className="mb-4 mt-10 text-xl font-semibold">Others</h3>
            <Link
              href="/tools"
              className="text-gray-400 transition hover:text-white"
            >
              Tools
            </Link>
          </div>

          {/*  */}
        </div>
      </div>
    </footer>
  );
}
